import React from 'react';

import { scrollToElement } from 'helpers';
import Logo from 'icons/talenteer_logo.svg';

interface Props {
  linkClass?: string;
  pageTitle?: string;
}

const isHomePage = () => {
  const url = typeof window !== 'undefined' ? window.location.href : '';

  return url.split('/').at(-1) === '';
};

export const LinkLogo = ({ linkClass, pageTitle }: Props) => (
  <a
    href="/"
    className={`header-logo-link ${linkClass}`}
    aria-label="Go to homepage"
    onClick={(e) => {
      if (isHomePage()) {
        scrollToElement('#flow', e);
      }
    }}
  >
    <Logo />
    {pageTitle && <p className="cluster-title">{pageTitle}</p>}
  </a>
);
